export enum NativeRequestMessage {
    CAN_NAVIGATE = 'canNavigate',
    DOWNLOAD = 'download',
    FINISH_PROCESS = 'finishProcess',
    GET_APPEARANCE_SETTING = 'getAppearanceSetting',
    GET_APP_TYPE = 'getAppType',
    GET_DEVICE_REGISTRATION_TOKEN = 'getDeviceRegistrationToken',
    GET_NFC_SUPPORT = 'getNfcSupport',
    GET_SELECTED_ACCOUNT = 'getSelectedAccount',
    GET_SELECTED_DEBIT_CARD = 'getSelectedDebitCard',
    GET_SELECTED_IDENTIFICATION = 'getSelectedIdentification',
    LOG_OUT = 'logOut',
    NAVIGATE_BACK = 'navigateBack',
    NEXT_ACTION = 'nextAction',
    SET_NAVIGATION = 'setNavigation',
    SET_CONTENTSIZE = 'setContentSize',
    SET_TITLE = 'setTitle',
    SET_USER = 'setUser',
    SIGN_NATIVE = 'signNative',
    START_IDENTIFICATION = 'startIdentification',
    START_TOKEN_REGISTRATION = 'startTokenRegistration'
}

export interface AppType {
    appType: NativeAppType;
}

export enum NativeAppType {
    BANKIEREN = 'Bankieren',
    BANKING = 'Banking',
    MIJN_KANTOOR = 'MijnKantoor'
}

export interface DeviceRegistrationToken {
    deviceRegistrationToken: string;
}

export interface NativeSelectedAccount {
    iban: string;
}

export interface NativeSelectedDebitCard {
    iban: string;
    sequenceId: string;
}

export interface NativeNavigation {
    back: boolean;
}

export interface NativeSelectedIdentification {
    identification: NativeIdentification;
}

export interface NativeCanNavigate {
    back: boolean;
}

export enum NativeIdentification {
    DEBITCARD = 'DEBITCARD',
    NAWG = 'NAWG',
    DIGICODE = 'DIGICODE',
    DIGIPAS = 'DIGIPAS'
}

export interface DeviceIsNfcCapable {
    result: boolean;
}

export enum IdType {
    PASSPORT = 'passport',
    NATIONAL_IDENTITY_CARD = 'idCard'
}

export enum FlowType {
    NFC = 'nfcOnly',
    NFC_AND_FACIAL_RECOGNITION = 'nfcFacialRecognition'
}

export interface ReadIdIdentificationResponse {
    result: IdentificationResult;
    sessionId: string;
    system?: string;
    reason?: string;
}

export enum IdentificationResult {
    IDENTIFICATION_SUCCESS = 'success',
    IDENTIFICATION_CANCELLED = 'cancelled',
    IDENTIFICATION_FAILURE = 'failure'
}

export interface NativeSign {
    result: NativeSignResult;
}

export enum NativeSignResult {
    SIGNING_CANCELLED = 'signingCancelled',
    SIGNING_DONE = 'signingDone'
}

export enum NativeProcessStatus {
    FAILED = 'failed',
    SUCCESS = 'success',
    CONTINUE = 'continue'
}

export interface NativeHeaderState {
    title: string;
    navigation: NativeNavigation;
}

export interface NativeUserDetails {
    name: string;
    group?: string;
}

export enum NativeAppearanceSettingOptions {
    AUTOMATIC = 'automatic',
    LIGHT = 'light',
    DARK = 'dark',
    DEFAULT = 'default'
}

export interface NativeAppearanceSetting {
    setting: NativeAppearanceSettingOptions;
}
